import { gql } from '@apollo/client'

const DISHES_AVAILABLE_FOR_QC_COUNTS_QUERY = gql`
  query dishesAvailableForQcCountsQuery(
    $menuId: ID
    $filters: DishFiltersInput!
  ) {
    dishesAvailableForQcCounts(menuId: $menuId, filters: $filters) {
      userId
      count
    }
  }
`

export default DISHES_AVAILABLE_FOR_QC_COUNTS_QUERY
